<app-import-nav />

@if (!loading) {
  <div>
    @if (referralPrescriberSpecialtyMappingImports.length > 0) {
      <section class="mt-3">
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'imports'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>STATUS</th>
              <th class="text-nowrap text-end">IMPORTED AT &#x25BC;</th>
              <th class="text-end">PROCESSED</th>
              <th class="text-end">ADDED</th>
              <th class="text-end">REMOVED</th>
              <th class="text-end">FAILURE MESSAGE</th>
            </tr>
          </thead>
          <tbody>
            @for (referralPrescriberSpecialtyMappingImport of referralPrescriberSpecialtyMappingImports; track referralPrescriberSpecialtyMappingImport) {
              <tr>
                <td>
                  {{ referralPrescriberSpecialtyMappingImport.status | titlecase }}
                </td>
                <td class="text-end">
                  {{ referralPrescriberSpecialtyMappingImport.createdAt | date: 'M/d/yyyy h:mm a' }}
                  <div>
                    <small>{{ referralPrescriberSpecialtyMappingImport.username }}</small>
                  </div>
                </td>
                <td class="text-end">{{ referralPrescriberSpecialtyMappingImport.processed | number: '' }}</td>
                <td class="text-end">{{ referralPrescriberSpecialtyMappingImport.added | number: '' }}</td>
                <td class="text-end">{{ referralPrescriberSpecialtyMappingImport.removed | number: '' }}</td>
                <td class="text-end">{{ referralPrescriberSpecialtyMappingImport.failureMessage }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section class="mt-3"><p>There are no imports.</p></section>
    }
  </div>
} @else {
  <section class="mt-3"><mat-spinner diameter="30" /></section>
}
